export default __webpack_public_path__ + "static/media/loopback.301fa810.svg";